import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon;
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import Glyphicon from '../Glyphicon/index.js';

/**
 *  `CloseButton` is a styled button used as a trigger to close components like a `Popover` or `BottomSheet`.
 *
 */
function CloseButton(_ref) {
  let {
    onClick = () => {},
    inverse = false,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("button", Object.assign({
    "data-cmp": "closeButton",
    className: clsx('close', {
      inverse
    }),
    onClick: onClick,
    "aria-label": "Close",
    type: "button"
  }, rest), _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "remove"
  })));
}
export default CloseButton;